import { type AnimationStep } from './AnimationPlayer';

export interface PauseAnimationStepProps {
  transitionTime: number;
}

export const PauseAnimationStep = (
  stepProps: PauseAnimationStepProps,
  setTimeoutManaged: (callback: () => void, delay: number) => void
): AnimationStep => {
  const { transitionTime } = stepProps;
  return {
    startStep: (onComplete: () => void) => {
      setTimeoutManaged(onComplete, transitionTime * 1000);
    },
  };
};
